import { makeStyles, withStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: 620,
    borderRadius: 12,
    backgroundColor: 'white',
    boxShadow: "0 1px 14px 7px rgba(0,0,0,0.05), 0 1px 3px 0 rgba(0,0,0,0.2)",
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },

  dialogStyle: {
    borderRadius: '12px !important',
    maxHeight: "100%",
    backgroundColor: 'transparent',
    [theme.breakpoints.down('md')]: {
        width: '100%',
        padding: '20px',
        margin: '50px 15px'
      },
  },

  iconContainer: {
    display: 'flex',
    alignItems: 'center',
  },

  title: {
    color: "rgba(0,0,0,0.87)",
    fontFamily: "Montserrat",
    fontSize: '2em',
    fontWeight: "400",
    textAlign: 'center',
    margin: 14,
  },

  cardBody: {
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlign: 'center',
    padding: '12px 2em',
    boxShadow: "0 1px 14px 7px rgba(0,0,0,0.05), 0 1px 3px 0 rgba(0,0,0,0.2)",
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    }
  },

  cardBodyContainer: {
    width: '100%',
    justifyContent: 'space-between',
    padding: '8px 2em',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    }
  },

  statusTitle: {
    color: "#121D22",
    fontFamily: "Montserrat",
    fontSize: '18px',
    fontWeight: "700",
    padding: '3px 2px 2px 3px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    }
  },

  statusBody: {
    color: "rgba(0,0,0,0.87)",
    fontFamily: "Montserrat",
    fontSize: '2em',
    fontWeight: "bold",
  },

  btn: {
    width: 175,
    height: '40px',
    fontFamily: "Montserrat",
    fontSize: '16px',
    fontWeight: "600",
    margin: "10px",
    padding: '10px 10px',
    color: '#202020',
    [theme.breakpoints.down('sm')]: {
        width: "100%",
        fontSize: '14px'
    }
  },

  flexBox: {
    display: 'flex',
    alignItems: 'center',
  },
  
  inputStyle: {
    color: "#535D6D",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "600"
  },

  labelStyle: {
    color: "#535D6D",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "400",
  },

  cardFooter: {
    width: '100%',
    textAlign: 'center',
    backgroundColor: "#fff",
    marginBottom: 30,
    [theme.breakpoints.down('sm')]: {
      padding: '8px 80px 0px',
      width: '94%'
    },
  },

  paragraph: {
    color: "#121D22",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "500",
    marginBottom: 8,
    marginTop: 20,
    textAlign: 'center'
 },

cardContainer: {
  width: '100%',
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-evenly',
  marginTop: 15,
},

cardContent: {
  display: 'flex'
},


textareaSection: {
  paddingTop: '16px',
  '& .MuiFormLabel-root': {
    asterisk: {
      color: 'red',
      '&$error': {
        color: 'red'
      },
    }
  },
  [theme.breakpoints.down('sm')]: {
    paddingTop: '15px'
  },
},

textArea: {
   color: "#202020",
  fontFamily: "Montserrat",
  fontSize: "14px",
  fontWeight: 500,
  width: '100%',
  padding: "10px",
  height: '56px',
  border: 'none',
  outline: 'none',
  borderRadius: '4px',
  border: '1px solid #9E9E9E',
  "&::placeholder": {    
    fontSize: '14px', 
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '1rem',
    fontFamily: 'Montserrat',
    fontWeight: 400,
    lineHeight: 1
   }
},

footerSection: {
  paddingTop: 12,
  paddingBottom: 30,
  [theme.breakpoints.down('sm')]: {
    paddingTop: 6,
    paddingBottom: 10
  },
},

cancelBtn: {
  width: 192,
  fontFamily: "Montserrat",
  fontSize: '1.6em',
  fontWeight: "600",
  letterSpacing: "0.53px",
  lineHeight: "19px",
  textAlign: "center",
  float: "right",
  border: "2px solid",
  height: '40px',
  boxShadow: '0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2)',
  borderColor: theme.palette.primary.main,
  [theme.breakpoints.down('xs')]: {
    width: 'auto',
    fontSize: '1.2em'
  },
},
saveBtnBox: {
  float: "left",
  [theme.breakpoints.down('sm')]: {
    float: "right",
    paddingRight: 30
  }
},
saveBtn: {
  width: 192,
  fontFamily: "Montserrat",
  fontSize: '1.6em',
  marginLeft: 20,
  fontWeight: "600",
  letterSpacing: "0.53px",
  lineHeight: "19px",
  textAlign: "center",
  height: '40px',
  color: theme.palette.primary.contrastText,
  [theme.breakpoints.down('xs')]: {
    width: 'auto',
    fontSize: '1.2em'
  },
},
chooseFile:{
  color: '#202020',
  fontFamily: 'Montserrat',
  fontSize: '10px',
  fontStyle: 'normal',
  fontWeight: '700',
  lineHeight: 'normal',
  marginRight:'15px',
  '&.info':{
    fontSize: '10px',
  },
  [theme.breakpoints.down('sm')]: {
    paddingTop: '4px'
  },
},
fileButton:{
  borderRadius: '4px',
  border: '1px solid #EDB36A',
  background: '#FFF',
  marginRight:'15px',
  paddingRight: '0px'
},
fileUpload:{
  display:'flex',
  alignItems:'center',
  marginTop:'10px',
  marginBottom:'15px',
  [theme.breakpoints.down('sm')]: {
    flexDirection:'column'
  },
},

documentValue1: {
  color: '#202020',
  fontFamily: "Montserrat",
  fontSize: "14px",
  lineHeight: "22px",
  fontWeight: '500',
  padding: '2px 0px 20px 34px',
  display:'flex',
  [theme.breakpoints.down('sm')]: {
     flexDirection:'column'
  }
},

fileName: {
  color: '#007FFF',
 fontFamily: 'Montserrat',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: '600',
  lineHeight: '20px',
  textDecorationLine: 'underline',
  marginRight:'15px',
  display:'flex',
  alignItems:'center',
  cursor: 'pointer'
},

uploadedImageContainer:{
  paddingRight:'40px',
  [theme.breakpoints.down('sm')]: {
    paddingRight:'0px',
  },
},
uploadedImage:{
  borderBottom: '3px solid #198100',
  color: '#202020',
  fontFamily: 'Montserrat',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '600',
  lineHeight: '16px',
  paddingBottom: '10px',
  marginBottom: '20px',
  display: 'flex',
  justifyContent: 'space-between'
},
imageText: {
  width: '285px',
  color: '#007FFF',
  fontFamily: 'Montserrat',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: '600',
  lineHeight: '16px',
  textDecoration: 'underline',
  paddingLeft: 10,
  paddingTop: 2,
  wordWrap: 'break-word',
  cursor: 'pointer',
  [theme.breakpoints.down('sm')]: {
    width:'235px'
  },
},
disableChooseBtn: {
  fontFamily: 'Montserrat',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: '600',
  lineHeight: 'normal',
  marginRight:'15px',
  [theme.breakpoints.down('sm')]: {
    paddingTop: '5px'
  },
},
disableFileBtn: {
  borderRadius: '4px',
  background: '#FFF',
  marginRight:'15px',
  paddingRight: '0px'
},
loader: {
  width: '100%',
  height: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
},

dialogClass: {
  '& .MuiDialog-paperWidthSm': {
    maxWidth: '620px',
    borderRadius: '16px'
  },
},
errorMsg: {
  fontSize: '1.4em',
  fontWeight: 'bold',
  marginBottom: 8,
  marginTop: 6,
  fontFamily: 'Montserrat',
  color: "red",
},
}));
